import axios from 'axios';
import { useSelector } from 'react-redux';
import { myStore } from  "../context/store"; // Import your store
import { alertDanger, alertWarning } from '../context/actions/toastAction';
import { loaderSet } from '../context/actions/loaderAction';



const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL, 
    // baseURL: "https://5sdt4x-ip-59-97-34-173.tunnelmole.net",
    // baseURL:"http://localhost:3000/",
   
    // baseURL:"https://112d-59-93-252-12.ngrok-free.app/v1",
    headers: {
      'Content-Type': 'application/json',
      'x-api-key':  process.env.REACT_APP_API_KEY,
     // 'Access-Control-Allow-Origin': "*"
      //  Authorization: `Bearer ${user.access_token}`

      // Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ1c2VyX2ZiODY4MzIxIiwiZW1haWwiOiJtYWRoYW5rdW1hcnJhamE2QGdtYWlsLmNvbSIsImlhdCI6MTcyODk4MzkzNCwiZXhwIjoxNzI5MDcwMzM0fQ.w8A4mAOTNDcp8tcmnQFPsuORdLsIwzuu5HNhVTvoH8I`
      
    }
  });

  
  apiClient.interceptors.request.use(
    async (config) => {
      const state = myStore.getState(); // Get the latest Redux state
      const token = state.user?.accessToken; // Access the token from the user reducer
  
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`; // Inject the token into headers
      
        // config.headers['Authorization'] = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InNla2FybmFkYXI0NTZAZ21haWwuY29tIiwiaWF0IjoxNzI5ODY0NDU4LCJleHAiOjE3Mjk4NjUzNTh9.alH32EhjBeqAt_R3H6DYJAoXI_0OpvsES8NH_hc8hGY`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  
  // Add response interceptor to handle token expiration
// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       // Handle token expiration (401 Unauthorized)
//       logoutUser();
//     }
//     return Promise.reject(error);
//   }
// );

// Response Interceptor
apiClient.interceptors.response.use(
  (response) => response, // Return the response if no error
  (error) => {
    if (error.response?.status === 403) {
      // Handle token expiration or unauthorized access
      console.error("Access token expired or unauthorized. Redirecting to login...");
      logoutUser();
    }

    return Promise.reject(error); // Reject the error for further handling
  }
);

// Logout Function
const logoutUser = () => {
  // Clear tokens and user data
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");

  // Dispatch actions to clear Redux state and set an alert
  myStore.dispatch({ type: "NULL_USER" });
  myStore.dispatch(loaderSet(true))
  myStore.dispatch(alertDanger("Session expired. Please log in again."));

  // Redirect to login page
  window.location.href = "/";
  setTimeout(() => {
    myStore.dispatch(loaderSet(false))
  }, 500);
};



  export default apiClient;
